import React, { useState } from "react";
import axios from "axios";
import Map from "./Map";

const BookingModal = ({ isOpen, onClose, service, userId }) => {
  const [serviceAddress, setServiceAddress] = useState("");
  const [serviceDate, setServiceDate] = useState("");
  const [serviceTime, setServiceTime] = useState("");
  const [comments, setComments] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);

  const handleBooking = () => {
    const bookingData = {
      user_id: userId,
      service_id: service.id,
      service_address: serviceAddress,
      latitude: selectedLocation ? parseFloat(selectedLocation.lat) : null,
      longitude: selectedLocation ? parseFloat(selectedLocation.lng) : null,
      comments: comments || "",
      service_date: serviceDate,
      service_time: `${serviceTime}:00`,
    };

    console.log("Booking Data:", bookingData);

    axios
      .post(
        "https://feniceshieldchemical.bwsoft.in/api/api/book-now/",
        bookingData
      )
      .then((response) => {
        console.log("Booking successful:", response.data);
        onClose();
      })
      .catch((error) => {
        console.error("Error booking service:", error);
      });
  };

  const handleServiceAddressClick = () => {
    setIsMapModalOpen(true);
  };

  const handleMapSelect = ({ lat, lng, address }) => {
    console.log("Map Selected Location:", { lat, lng, address });
    setSelectedLocation({ lat, lng });
    setServiceAddress(address); // Update address with selected location's address
    setIsMapModalOpen(false); // Close map modal
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Book {service.name}</h2>

        <input
          type="text"
          placeholder="Click to Select Location"
          value={
            selectedLocation
              ? `Lat: ${selectedLocation.lat}, Lon: ${selectedLocation.lng}`
              : "No location selected"
          }
          readOnly
          onClick={handleServiceAddressClick} // Open map modal on click
        />
        <input
          type="text"
          placeholder="Service Address (e.g., Door No.)"
          value={serviceAddress}
          onChange={(e) => setServiceAddress(e.target.value)} // Editable address
        />
        <input
          type="date"
          placeholder="Service Date"
          value={serviceDate}
          onChange={(e) => setServiceDate(e.target.value)}
        />
        <input
          type="time"
          placeholder="Service Time"
          value={serviceTime}
          onChange={(e) => setServiceTime(e.target.value)}
        />
        <textarea
          placeholder="Comments"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
        <div className="d-flex justify-content-center align-items-center gap-3">
          {" "}
          <button onClick={onClose} className="red-button">
            Close
          </button>{" "}
          <button onClick={handleBooking}>Book Now</button>
        </div>
      </div>

      {/* Map Modal */}
      {isMapModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" id="map-modal">
            <h2>Select Location on Map</h2>
            <Map onSelect={handleMapSelect} />
            <button onClick={() => setIsMapModalOpen(false)}>Close Map</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingModal;
